const teamTypeTransformer = (response, args) => {
  return response?.map(item => ({ ...item, value: !!args?.transformKey ? item.id + "" : item.key }))
}

export default teamTypeTransformer
